export enum CodingType {
  DMC = 1,
  Balluf125kHz = 2,
  Balluf70455kHz = 3,
  Balluf1356MHz = 4,
  PFOpconClassic = 5,
  PFOpconPlus = 6,
  VisualCheck = 7,
  NFC = 8
}

export type CodingTypeValue = CodingType | 'N/A';
export const AUTO_GENERATED_TOOL_CODE_CODING_TYPE = CodingType.VisualCheck;

export interface CodingTypeOption {
  label: string;
  value: CodingTypeValue;
}

export const CODING_TYPE_NA_OPTION: CodingTypeOption = {
  label: 'N/A',
  value: 'N/A'
};

export const CODING_TYPE_LABELS: Record<CodingType, string> = {
  [CodingType.DMC]: '1 - DMC',
  [CodingType.Balluf125kHz]: '2 - Balluf 125 kHz',
  [CodingType.Balluf70455kHz]: '3 - Balluf 70/455 kHz',
  [CodingType.Balluf1356MHz]: '4 - Balluf 13.56 MHz',
  [CodingType.PFOpconClassic]: '5 - P&F Opcon Classic',
  [CodingType.PFOpconPlus]: '6 - P&F Opcon Plus',
  [CodingType.VisualCheck]: '7 - Visual Check (Mechanic & Electric)',
  [CodingType.NFC]: '8 - NFC'
};

export const CODING_TYPE_OPTIONS: CodingTypeOption[] = [
  CODING_TYPE_NA_OPTION,
  ...Object.keys(CODING_TYPE_LABELS).map(key => ({
    label: CODING_TYPE_LABELS[key as unknown as CodingType],
    value: Number(key) as CodingType
  }))
];

export function normalizeCodingTypeValue(value: unknown): CodingTypeValue {
  if (value === 'N/A' || value === null || value === undefined || value === '') {
    return 'N/A';
  }

  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue as CodingType : 'N/A';
}

export function isNACodingType(value: unknown): boolean {
  return normalizeCodingTypeValue(value) === 'N/A';
}

export function isAutoGeneratedToolCodeCodingType(value: unknown): boolean {
  return normalizeCodingTypeValue(value) === AUTO_GENERATED_TOOL_CODE_CODING_TYPE;
}

export function buildAutoGeneratedToolCode(toolUid: string): string {
  return toolUid ? `${toolUid}.jpg` : '';
}
